export default __webpack_public_path__ + "static/media/nucleo.0818662f.jpeg";